import type { GridPaginationModel, GridSortModel } from '@mui/x-data-grid'
import type { SetPaginationRequest } from '../types'

export const handleSortModelChange = (
  model: GridSortModel,
  setPaginationRequest: SetPaginationRequest,
) => {
  setPaginationRequest((prev) => ({
    ...prev,
    OrderBy: model[0]?.field ?? 'verifiedDate',
    OrderByOrder: model[0]?.sort ?? 'asc',
  }))
}

export const handlePaginationModelChange = (
  model: GridPaginationModel,
  setPaginationRequest: SetPaginationRequest,
) => {
  setPaginationRequest((prev) => ({
    ...prev,
    Skip: model.page * model.pageSize,
    Take: model.pageSize,
  }))
}

export const dateFormatter = (date: Date) => {
  if (Number.isNaN(date.valueOf())) return ''
  return date.toLocaleDateString(undefined, {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })
}
